<template>
  <NuxtLink
    :to="buttonLink"
    :class="`transform select-none items-center rounded px-4 py-3 text-min text-white shadow-sm hover:-translate-y-0.5 disabled:cursor-not-allowed disabled:border-gray-300 disabled:bg-disabled disabled:text-tertiary disabled:shadow-sm ${defaultBgColors} ${classes}`"
  >
    <span>
      <slot />
    </span>
  </NuxtLink>
</template>

<script>
export default {
  name: 'PrimaryButtonLink',

  props: {
    buttonLink: {
      type: String,
      default: '/',
    },
    defaultBgColors: {
      type: String,
      default: 'bg-main-primary hover:bg-main-secondary active:bg-main-primary',
    },
    classes: {
      type: String,
      default: '',
    },
  },
}
</script>
